import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, DrawerBody, DrawerFooter } from '@chakra-ui/react';

import { analyticsIds } from '../../../../../constants/analyticsIds';
import { CypressIds } from '../../../../../constants/cypressIds';
import {
  createInsured,
  selectStagedInsuredCountry,
  setCreateInsuredActiveStep
} from '../../../../../redux/modules/insured';
import { insuredListSearch } from '../../../../../redux/modules/insuredList';
import { removePhoneNumberFormat } from '../../../../../utils/formatPhoneUtil';

import InsuredForm from './InsuredForm';

const CreateInsuredForm = () => {
  const dispatch = useDispatch();
  const stagedCountry = useSelector(selectStagedInsuredCountry);
  const [isSubmitting, setSubmitting] = useState(false);

  const onSubmit = async data => {
    setSubmitting(true);

    const newInsuredInfo = {
      insured_company_name: data.insuredCompanyName,
      insured_contact_name: data.insuredCompanyName,
      insured_email: data.insuredEmail,
      insured_cc: data.insuredCc || '',
      external_id: data.externalId,
      insured_description: data.insuredDescription,
      insured_address: data.insuredAddress,
      insured_city: data.insuredCity,
      insured_state: data.insuredState,
      insured_zip: data.insuredZip,
      country: stagedCountry.code,
      insured_phone: removePhoneNumberFormat(data.insuredPhone),
      insured_phone2: removePhoneNumberFormat(data.insuredPhone2),
      insured_type: data.insuredType
    };

    const response = await dispatch(createInsured(newInsuredInfo));

    if (response) {
      dispatch(insuredListSearch.setPostCreateFilter());
      dispatch(insuredListSearch.getPage());
      dispatch(setCreateInsuredActiveStep(1));
    }

    setSubmitting(false);
  };

  return (
    <>
      <DrawerBody>
        <InsuredForm formId="createInsuredForm" onSubmit={onSubmit} />
      </DrawerBody>
      <DrawerFooter>
        <Button
          data-analytics-id={analyticsIds.insuredsListPage.saveNewInsuredButton}
          data-cy={CypressIds.insuredsSaveNewInsuredButton}
          dusk={analyticsIds.insuredsListPage.saveNewInsuredButton}
          form="createInsuredForm"
          isDisabled={isSubmitting}
          type="submit"
          width="100%"
        >
          Save Insured
        </Button>
      </DrawerFooter>
    </>
  );
};

export default CreateInsuredForm;
